"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookbookDebugger = exports.setRailgunFees = void 0;
const railgun_config_1 = require("../models/railgun-config");
const cookbook_debug_1 = require("../utils/cookbook-debug");
const setRailgunFees = (networkName, shieldFeeBasisPoints, unshieldFeeBasisPoints) => {
    railgun_config_1.RailgunConfig.SHIELD_FEE_BASIS_POINTS_FOR_NETWORK[networkName] =
        shieldFeeBasisPoints;
    railgun_config_1.RailgunConfig.UNSHIELD_FEE_BASIS_POINTS_FOR_NETWORK[networkName] =
        unshieldFeeBasisPoints;
};
exports.setRailgunFees = setRailgunFees;
const setCookbookDebugger = (cookbookDebugger) => {
    cookbook_debug_1.CookbookDebug.setDebugger(cookbookDebugger);
};
exports.setCookbookDebugger = setCookbookDebugger;
